import core from '@gin-betting/core';

import { Product } from 'app-constants';

const {
    utils: { getBettingOptions },
} = core;

export default function getProductName(): Product {
    const { host } = window.location;
    const { staticEndpoint } = getBettingOptions().url;

    switch (true) {
        case host === 'ggbet.ru': {
            return Product.ru;
        }

        case host === 'ggbet.com': {
            return Product.com;
        }

        case host === 'ggbet.ua': {
            return Product.ua;
        }

        case staticEndpoint.includes('ggbet'): {
            return Product.bet;
        }

        default: {
            if (__DEV__) {
                return Product.bet;
            }

            return Product.unknown;
        }
    }
}
